<template>
  <div>
    <div v-if="showInfoBlock" class="resume-downloaded-documents__info">
      <div class="resume-downloaded-documents__info-content">
        <div class="resume-downloaded-documents__info-item">
          <span class="resume-downloaded-documents__info-item-name">
            {{ $tResumePage('Passport series and number') }}
          </span>
          <span>
            {{ $get(mainInfo, 'items[8].answer') }}
          </span>
        </div>
        <div class="resume-downloaded-documents__info-item">
          <span class="resume-downloaded-documents__info-item-name">
            {{ $tResumePage('Passport country of issue') }}
          </span>
          <span>
            {{ $get(mainInfo, 'items[7].answer') }}
          </span>
        </div>
        <div class="resume-downloaded-documents__info-item">
          <span class="resume-downloaded-documents__info-item-name">
            {{ $tResumePage('Passport expiration date') }}
          </span>
          <span>
            {{ $get(mainInfo, 'items[6].answer') }}
          </span>
        </div>
        <div class="resume-downloaded-documents__info-item">
          <span class="resume-downloaded-documents__info-item-name">
            {{ $tResumePage('Passport gave out') }}
          </span>
          <span>
            {{ $get(mainInfo, 'items[10].answer') }}
          </span>
        </div>
      </div>
    </div>
    <CollapseTransition>
      <div v-if="showFiles">
        <div class="resume-downloaded-documents__accordion-content">
          <ResumeDownloadedDocumentsGroupList :documents="documentsInner"
                                              :viewedPassportPages="viewedPassportPages"
                                              :selectedDocumentsIds="selectedDocumentsIds"
                                              @toggle-select="$emit('toggle-select', $event)"/>
        </div>
      </div>
    </CollapseTransition>
  </div>
</template>

<script>
  import {CollapseTransition} from 'vue2-transitions'
  import ResumeDownloadedDocumentsGroupList from './ResumeDownloadedDocumentsGroupList'

  export default {
    name: 'ResumeDownloadedDocumentsGroup',
    components: {
      ResumeDownloadedDocumentsGroupList,
      CollapseTransition
    },
    props: {
      documents: {
        type: Array,
        default: () => ([])
      },
      viewedPassportPages: Array,
      archiveNames: Object,
      showFiles: Boolean,
      selectedDocumentsIds: Array,
      mainInfo: Object
    },
    data(vm) {
      return {
        pendingSelected: false,
        pendingAll: false,
        documentsInner: JSON.parse(JSON.stringify(vm.documents)),
      }
    },
    computed: {
      resumeId() {
        return this.$route.params.resumeId;
      },
      showInfoBlock() {
        return [8, 7, 6, 10].some(n => this.$get(this.mainInfo, `items[${n}].answer`));
      },
    },
    methods: {


    },
    watch: {
      documents(documents) {
        this.documentsInner = JSON.parse(JSON.stringify(documents))
      }
    }
  }
</script>

<style lang="less">

</style>
